<div class="user-summary">
  <div class="user-summary__avatar">
    <img *ngIf="avatarUrl" [ngSrc]="avatarUrl" alt="user avatar" height="64" width="64" />
  </div>
  <div class="user-summary__details">
    <h4 class="user-summary__name">{{ name }}</h4>
    <h5 *ngIf="email" class="user-summary__email">{{ email }}</h5>
  </div>
</div>
